import busVue from "@/common/utils/busVue";
import Vue from 'vue';
import SmartPlayer from '@src/components/common/media-player/video-smallNew.vue';
// import SmartPlayer from '@src/components/common/media-player/smart-player.vue';
const mixin = {
  data () {
    return {
      key: 0
      // changIndex: ''
    }
  },
  beforeDestroy () {
    // this.destroyPlayer()
  },
  activated () {
    this.playerComponent ? this.play() : ""
  },
  deactivated () {
  },
  methods: {
    // 元素互换
    DratChange (father, child) {
      let div = child
      let domF = father
      let container = null
      for (let i = 0; i < div.length; i++) {
        div[i].ondragstart = function () {
          container = this
        }
        div[i].ondragover = function () {
          event.preventDefault()
        }
        div[i].ondrop = function () {
          if (container != null && container != this) {
            let temp = document.createElement("div")
            domF.replaceChild(temp, this)
            domF.replaceChild(this, container)
            domF.replaceChild(container, temp)
          }
        }
      }
    },
    // 播放实况
    playLiveVideo (item, index, streamType) {
      this.loadingMessage = "视频请求中..."
      const param = {
        deviceId: item.deviceId || item.thirdCameraId,
        protocol: window.systemConfig.MEDIA_TYPE,
        streamType: streamType || item.streamType || 'SUB',
      };
      this.playerLoading = true;
      index ? this.destroyPlayer() : ""
      item.axiosNum ? item.axiosNum += 1 : item.axiosNum = 1
      this.$fetch(this.$api.common.video.queryRealTimeVideoRtsp, param).then(
        res => {
          if (!res.success) {
            this.loadingMessage = res.msgContent
            this.key += 1
            if (item.axiosNum < 3) {
              setTimeout(() => {
                this.playLiveVideo(item, index)
              }, 100);
            }
            this.isPatrol ? this.showNextB = true : ''
            return
          } else {
            if (!res.returnObj || !res.returnObj.url) {
              this.loadingMessage = "视频云播放地址为空"
              if (item.axiosNum < 3) {
                setTimeout(() => {
                  this.playLiveVideo(item, index)
                }, 100);
              }
              this.isPatrol ? this.showNextB = true : ''
              return
            }
            this.isPatrol ? this.showNextB = false : ''
            item.axiosNum = 1
            item.streamId = res.returnObj.streamId || '';
            if (streamType) {
              item.streamType = streamType;
              this.$message.success("切换成功，已切换至" + (streamType == 'MAIN' ? '主码流' : '子码流'));
            }
            const _data = res.returnObj;
            const playUrl = _data.url;
            this.loadVideo(playUrl, item);
            this.playerLoading = false;
          }
        }
      );
    },
    // 播放成功回调
    playSuccess () { },
    // 挂载播放器实例
    loadVideo (url, item) {
      const PlayerVue = Vue.extend(SmartPlayer);
      // 挂载播放器实例
      this.playerComponent = new PlayerVue({
        propsData: {
          playUrl: url,
          wnd: this.changIndex || 1,
          isClose: false,
          isBarList: [1, 3, -1, 4, 6, -2],
          deviceInfo: item,
          videoType: item.videoType || 'flv'
        }
      }).$mount();
      // 注册窗口关闭事件
      this.playerComponent.$on('close', wndn => {
        this.destroyPlayer();
      });
      // 适合单窗口重新播放视频流
      this.playerComponent.$on('reloadVideo', (wndn, type, info) => {

        if (type > 0) {
          // 重新请求123
          if (type > 2) {
            // 连续请求三次即可
            return
          }
          var box = document.querySelector(".smart-player");
          box ? box.remove() : ""
          this.playerLoading = true;
          this.playLiveVideo(info, wndn)
          return
        }
      });
      // 视频播放
      this.playerComponent.$on('pause', wndn => {
        this.playPause();
      });
      // 视频暂停
      this.playerComponent.$on('play', wndn => {
        this.playPlay();
      });
      // 视频码流切换
      this.playerComponent.$on('checkType', info => {
        // this.playPlay();
        this.playLiveVideo(info.deviceInfo, info.index, info.type);
      });
      // 视频拉流报错
      this.playerComponent.$on('playError', wndn => {
        this.playError();
      });
      //视频拉流成功
      this.playerComponent.$on('playSuccess', wndn => {
        this.playSuccess()
      });
      this.$refs['playerBox'].appendChild(this.playerComponent.$el);
    },
    // 混入的对象的方法会覆盖这里
    playPlay () { },
    playPause () { },
    // 替换视频源
    cutPlayLiveVideo (info, index, type) {
      this.playLiveVideo(info, index, type)
    },
    // 获取任意一个空闲窗口
    validFreeWnd (useArray) {
      let wnd = 0;
      for (let i of this.totalWnd) {
        if (useArray.some(v => i === v)) {
          continue;
        } else {
          wnd = i;
          break;
        }
      }
      return wnd;
    },
    //关闭
    destroyPlayer () {
      this.closeVideo()
      if (!this.playerComponent) return;
      this.playerComponent.$off();
      this.playerComponent.clearSetTime();
      this.playerComponent.close();
      this.playerComponent.$destroy();
      this.playerComponent = null;
    },
    playError () {
      this.isPatrol ? this.showNextB = true : ''
    },
    closeVideo () { },
    // 暂停
    pause (play) {
      this.playerComponent.pause();
    },
    // 播放
    play (play) {
      this.playerComponent.play();
    },
  }
}

export default mixin